import { createEvent } from 'effector';
import { combineEvents } from 'patronum';

export const putZoom10HexagonsEv = createEvent();

export const formMutatedDict10Ev = createEvent();

export const resetZoom10ByMetricsEv = createEvent();

export const putCalculated10HexagonsEv = createEvent();

export const putFilteredZoom10HexagonsEv = createEvent();

export const filterZoom10GradientEv = createEvent();

export const toggleExtrusionEv = createEvent();

export const changeActiveExtPropEv = createEvent();

export const calculateExcByPresetEv = createEvent();

export const calculateMetricByPresetEv = createEvent();

export const putCalculatedExcByPresetEv = createEvent();

export const putRawHex1Ev = createEvent();
export const putRawHex2Ev = createEvent();
export const putRawHex3Ev = createEvent();
export const putRawHex4Ev = createEvent();
export const putRawHex5Ev = createEvent();
export const putRawHex6Ev = createEvent();
export const putRawHex7Ev = createEvent();
export const putRawHex8Ev = createEvent();
export const putRawHex9Ev = createEvent();

export const combineZoom10DataEv = combineEvents({
  events: {
    zoom_10_hexagons: putZoom10HexagonsEv,
    raw_hex_1: putRawHex1Ev,
    raw_hex_2: putRawHex2Ev,
    raw_hex_3: putRawHex3Ev,
    raw_hex_4: putRawHex4Ev,
    raw_hex_5: putRawHex5Ev,
    raw_hex_6: putRawHex6Ev,
    raw_hex_7: putRawHex7Ev,
    raw_hex_8: putRawHex8Ev,
    raw_hex_9: putRawHex9Ev,
  },
});
